// extracted by mini-css-extract-plugin
export default {"green":"USDAmount_green__m6IS5"};